module.exports = __webpack_public_path__ + "static/media/enoch.e420c069.png";